import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { Helmet } from 'react-helmet';
import OrganisationsFilterContextProvider from '../common/components/containers/OrganisationsFilterContextProvider';
import TenantInfoContextProvider from '../common/components/containers/TenantInfoContextProvider/TenantInfoContextProvider';
import NextTreeStore from '../common/components/dataViews/NextTree/store/NextTreeStore';
import Breadcrumbs from '../common/components/utils/Breadcrumbs';
import BreadcrumbsStore from '../common/components/utils/Breadcrumbs/BreadcrumbsStore';
import Modal from '../common/components/utils/Modal';
import Popover from '../common/components/utils/Popover';
import SocketClientContextProvider from '../common/data/socket/SocketClientContextProvider';
import QuickLinksContextProvider from '../common/components/containers/QuickLinksContextProvider';
import AppConfig from './AppConfig';
import Routes from './Routes';
const App = ({ apolloClient, appConfig }) => (<div className="application">
    <Helmet defaultTitle="Edana">
      <html className="no-js" lang="en"/>

      <meta charSet="utf-8"/>
      <meta content="ie=edge" httpEquiv="x-ua-compatible"/>
      <meta content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no" name="viewport"/>
      {appConfig.googleSiteVerification ? (<meta content={appConfig.googleSiteVerification} name="google-site-verification"/>) : null}

      <link href="/images/favicon.png" rel="icon" type="image/png"/>

      <link href="https://fonts.googleapis.com/css?family=Roboto:400,300,100,500,700,900" rel="stylesheet" type="text/css"/>
      <base href="/"/>
    </Helmet>

    <ApolloProvider client={apolloClient}>
      <AppConfig.Provider value={appConfig}>
        <NextTreeStore>
          <BreadcrumbsStore>
            <TenantInfoContextProvider>
              <OrganisationsFilterContextProvider>
                <Modal.Provider>
                  <Popover.Provider>
                    <SocketClientContextProvider>
                      <QuickLinksContextProvider>
                        <Breadcrumbs.AutoDocumentTitle rootTitle="Edana"/>
                        <Routes />
                      </QuickLinksContextProvider>
                    </SocketClientContextProvider>
                  </Popover.Provider>
                </Modal.Provider>
              </OrganisationsFilterContextProvider>
            </TenantInfoContextProvider>
          </BreadcrumbsStore>
        </NextTreeStore>
      </AppConfig.Provider>
    </ApolloProvider>
  </div>);
export default App;
